// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global reset to remove default margins and paddings */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Full height layout */
html, body, #root {
  height: 100%;
}

/* Header style */
.header {
  padding: 0.2rem;
  background-color: #4991c9; /* Example blue header */
  color: white;
  text-align: center;
  font-size: x-small;
  margin-bottom: 10px;
  height: 2rem;
  font-size: larger;
  font-weight: 600;
}

/* Footer style */
.footer {
  padding: 0.2rem;
  background-color: #4991c9; /* Example blue header */
  color: white;
  text-align: center;
  font-size: x-small;
  margin-top: 10px;
}

.App {
  text-align: center;
  display: flex; /* Use flex layout */
  flex-direction: column; /* Arrange children (sidebar and content) in a row */
  height: 100vh; /* Full height of the viewport */
  width: 100vw; /* Full width of the viewport */
  overflow-x: hidden; /* Prevent horizontal scroll */
  background-color: #e6ebee;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}


.ReactModal__Overlay {
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.75);
}

.ReactModal__Content {
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  marginRight: -50%;
  transform: translate(-50%, -50%);
  border: 1px solid #ccc;
  background: #fff;
  overflow: auto;
  WebkitOverflowScrolling: 'touch';
  borderRadius: '4px';
  outline: 'none';
  padding: '20px';
  width: '50%';
  max-width: '600px'; /* Maximum width */
  max-height: '80vh'; /* Maximum height */
  overflow-y: 'auto'; /* Scroll if content is taller */
}

.content {
  flex-grow: 1; /* Allows the content to grow to available space */
  transition: margin-left 0.3s; /* Smooth transition for the margin */
  display: flex; /* If you want to use Flexbox inside .content */
  flex-direction: column; /* Directs children of content in a column */
  overflow-x: auto; /* Adds horizontal scrolling if content overflows */
  overflow-y: auto;
  margin-left: 0;
  padding: 1rem;
}

.content-expanded {
  margin-left: 180px; /* Width of the expanded 180 sidebar */
}

.content-collapsed {
  margin-left: 50px; /* Width of the collapsed sidebar */
}

.App-header {
  /* ... other styles ... */
  min-height: 0; /* Instead of 100vh, otherwise it will push content down */
}`, "",{"version":3,"sources":["webpack://./src/app/App.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,yBAAyB,EAAE,wBAAwB;EACnD,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,yBAAyB,EAAE,wBAAwB;EACnD,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa,EAAE,oBAAoB;EACnC,sBAAsB,EAAE,oDAAoD;EAC5E,aAAa,EAAE,gCAAgC;EAC/C,YAAY,EAAE,+BAA+B;EAC7C,kBAAkB,EAAE,8BAA8B;EAClD,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB,EAAE,kBAAkB;EACtC,kBAAkB,EAAE,mBAAmB;EACvC,kBAAkB,EAAE,gCAAgC;AACtD;;AAEA;EACE,YAAY,EAAE,kDAAkD;EAChE,4BAA4B,EAAE,qCAAqC;EACnE,aAAa,EAAE,+CAA+C;EAC9D,sBAAsB,EAAE,4CAA4C;EACpE,gBAAgB,EAAE,mDAAmD;EACrE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,sCAAsC;AAC5D;;AAEA;EACE,iBAAiB,EAAE,mCAAmC;AACxD;;AAEA;EACE,yBAAyB;EACzB,aAAa,EAAE,0DAA0D;AAC3E","sourcesContent":["/* Global reset to remove default margins and paddings */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* Full height layout */\nhtml, body, #root {\n  height: 100%;\n}\n\n/* Header style */\n.header {\n  padding: 0.2rem;\n  background-color: #4991c9; /* Example blue header */\n  color: white;\n  text-align: center;\n  font-size: x-small;\n  margin-bottom: 10px;\n  height: 2rem;\n  font-size: larger;\n  font-weight: 600;\n}\n\n/* Footer style */\n.footer {\n  padding: 0.2rem;\n  background-color: #4991c9; /* Example blue header */\n  color: white;\n  text-align: center;\n  font-size: x-small;\n  margin-top: 10px;\n}\n\n.App {\n  text-align: center;\n  display: flex; /* Use flex layout */\n  flex-direction: column; /* Arrange children (sidebar and content) in a row */\n  height: 100vh; /* Full height of the viewport */\n  width: 100vw; /* Full width of the viewport */\n  overflow-x: hidden; /* Prevent horizontal scroll */\n  background-color: #e6ebee;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n.ReactModal__Overlay {\n  z-index: 10;\n  background-color: rgba(0, 0, 0, 0.75);\n}\n\n.ReactModal__Content {\n  top: 50%;\n  left: 50%;\n  right: auto;\n  bottom: auto;\n  marginRight: -50%;\n  transform: translate(-50%, -50%);\n  border: 1px solid #ccc;\n  background: #fff;\n  overflow: auto;\n  WebkitOverflowScrolling: 'touch';\n  borderRadius: '4px';\n  outline: 'none';\n  padding: '20px';\n  width: '50%';\n  max-width: '600px'; /* Maximum width */\n  max-height: '80vh'; /* Maximum height */\n  overflow-y: 'auto'; /* Scroll if content is taller */\n}\n\n.content {\n  flex-grow: 1; /* Allows the content to grow to available space */\n  transition: margin-left 0.3s; /* Smooth transition for the margin */\n  display: flex; /* If you want to use Flexbox inside .content */\n  flex-direction: column; /* Directs children of content in a column */\n  overflow-x: auto; /* Adds horizontal scrolling if content overflows */\n  overflow-y: auto;\n  margin-left: 0;\n  padding: 1rem;\n}\n\n.content-expanded {\n  margin-left: 180px; /* Width of the expanded 180 sidebar */\n}\n\n.content-collapsed {\n  margin-left: 50px; /* Width of the collapsed sidebar */\n}\n\n.App-header {\n  /* ... other styles ... */\n  min-height: 0; /* Instead of 100vh, otherwise it will push content down */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
